import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './AboutUs.css'; // Optional: for styling

const FAQItem = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="faq-item">
            <div className="faq-question" onClick={toggleOpen}>
                <h3>{question}</h3>
            </div>
            {isOpen && <div className="faq-answer">{answer}</div>}
        </div>
    );
};

const AboutUs = () => {
    const faqs = [
        {
            question: <>A Brief History of Value</>,
            answer: <>
            For some in the workforce, they are familiar with a 5½ day work week. Children could camp out in the mother's office lounge after school. <br/><br/>
            <b>Value?</b> 41.25h office presence plus overtime <br/><br/>
            For others, they <i>live out of suitcase</i>, hot-desking on public transportation, collecting frequent flyer miles and hotel points as they globetrot. <br/><br/>
            <b>Value?</b> Geographical and temporal availability for bespoke tasks.
            </>
        },
        {
            question: <>Inspiration</>,
            answer: <>
            Two decades ago, the Toyota Production System had already established itself as a best practice for just-in-time assembly lines. <br/><br/>
            An interesting function in the literature was the <i>water spider</i> (水すまし). <br/><br/>
            This term refers to the role responsible for transporting materials to the production line, ensuring a smooth and efficient workflow.<br/><br/>
            As technology evolves to enable enterprise to discretise work packages, business automation (ever larger packages) and the rise of edge cases (ever small packages) go hand-in-hand.<br /><br />
            </>
        },
        {
            question: <>What is Deliveranz<img src="./rickshaw.png" alt="Rickshaw" style={{ width: '40px', height: '40px' }}/>?</>,
            answer: <>Deliveranz is a platform that connects expertise with small enterprises without the overheads of office presence.<br /><br />
            We are the <i>water spiders</i> that keep businesses running smoothly. <br /><br />
            We deliver value through business automation with the expertise of experienced professionals.
            </>
        }
    ];

    return (
        <>
            {/* <div style={{ textAlign: 'center', backgroundImage: 'url(/asphalt.jpg)', backgroundRepeat: 'repeat', backgroundSize: 'auto', backgroundPosition: 'center', backgroundAttachment: 'fixed', minHeight: '100vh' }}> */}
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <h1 className="card-title">About Us</h1>
                <div className="faq-container">
                    
                    {faqs.map((faq, index) => (
                        <FAQItem key={index} question={faq.question} answer={faq.answer} />
                    ))}
                </div>
                <Link to="/">Go back to Home</Link>
            </div>
        </>
    );
};

export default AboutUs;
